/**
 * If we have a full url, get pathName, else return string as is.
 * If the passed 'str' is invalid, return an empty string which will do nothing.
 * @param str
 * @returns {string}
 */
export function pathnameFromString(str: string) {
  const matchedString = typeof str === 'string' ? str : '';
  const [, pathName = ''] = matchedString.match(/(?:https?:\/\/[^/\r\n]+)(\/[^\r\n]*)?/) || [];

  return pathName;
}

export function insertCategoryShopToUrl(str: string, replaceWith: string) {
  const dirs = str.split('/');
  dirs.splice(dirs.length - 1, 0, replaceWith);

  return dirs.join('/');
}
